export default __webpack_public_path__ + "static/media/lemlogos.5c3557b0.png";